<script>
    import { navigate } from 'svelte-routing'
    import {
        Button, Card, CardBody, CardHeader,
        CardSubtitle, CardText
    } from 'sveltestrap'
    import date from 'date-and-time'

    let className = ''
    export { className as class }
    export let task = {}

</script>

<style>
    .cardHeader :global(.card-header) {
        background-color: #fff;
        font-weight: bold;
    }
</style>

<div class="cardHeader">
    <Card class={className} >
        <CardHeader>
            <h4 class="float-left">{(task.title) ? task.title : ''}</h4>
        </CardHeader>
        <CardBody>
            <CardSubtitle class="font-weight-bold">{(task.address && task.address.address1) ? task.address.address1 : ''}</CardSubtitle>
            <CardSubtitle class="font-weight-bold">{(task.address && task.address.address2) ? task.address.address2 : ''}</CardSubtitle>
            <CardSubtitle class="font-weight-bold">{(task.address && task.address.postalCode) ? task.address.postalCode+' ' : ''} {(task.address && task.address.city) ? task.address.city : ''}</CardSubtitle>
            <CardSubtitle class="font-weight-bold">{(task.address && task.address.state ? task.address.state : '')}</CardSubtitle>
            <CardSubtitle class="font-weight-bold">{(task.address && task.address.country) ? task.address.country : ''}</CardSubtitle>
        </CardBody>
        <CardBody>
            <CardText><b>State:</b> {(task.state) ? task.state.toUpperCase() : ''}</CardText>
            <CardText><b>Expire date:</b> { (task.expire) ? date.format(task.expire, 'DD-MM-YYYY') : ''}</CardText>
            <CardText><b>Geolocation:</b> [{ (task.geolocation) ? task.geolocation : ''}]</CardText>
            <CardSubtitle class="font-weight-bold">Summary:</CardSubtitle>
            <CardText>{(task.summary) ? task.summary : ''}</CardText>
            <CardSubtitle class="font-weight-bold">Description:</CardSubtitle>
            <CardText>{(task.description) ? task.description : ''}</CardText>
            <Button color="primary" onclick={() => navigate(`/tasks/edit/${task.id}`)} disabled={(!task.id)}>Edit task</Button>
        </CardBody>
    </Card>
</div>